import { Component, input } from '@angular/core';
import type { EmojiData } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';

@Component({
  selector: 'onyx-emoji',
  imports: [EmojiComponent],
  templateUrl: './onyx-emoji.component.html',
  styleUrl: './onyx-emoji.component.scss',
})
export class OnyxEmojiComponent {
  public readonly name = input.required<string | EmojiData>();
  public readonly size = input(16);
}
